export const COOKIE_CONSENT_STORAGE_KEY = "cookie_consent";
export const LEGACY_COOKIE_ACCEPTED_KEY = "cookies_accepted";
export const COOKIE_CONSENT_UPDATED_EVENT = "cookie-consent-updated";

export const requiredCookiePreferences = {
  necessary: true,
  statistics: false,
  marketing: false,
};

export const defaultCookiePreferences = {
  necessary: true,
  statistics: true,
  marketing: true,
};

export const normalizeCookieCategories = (categories = defaultCookiePreferences) => ({
  necessary: true,
  statistics: categories?.statistics !== false,
  marketing: categories?.marketing !== false,
});

export const createConsentPayload = (mode, categories) => ({
  mode,
  categories: normalizeCookieCategories(categories),
  savedAt: new Date().toISOString(),
});

export const getConsentMode = (categories = defaultCookiePreferences) => {
  const normalizedCategories = normalizeCookieCategories(categories);

  return {
    functionality_storage: "denied",
    personalization_storage: "denied",
    analytics_storage: normalizedCategories.statistics ? "granted" : "denied",
    ad_storage: normalizedCategories.marketing ? "granted" : "denied",
    ad_user_data: normalizedCategories.marketing ? "granted" : "denied",
    ad_personalization: normalizedCategories.marketing ? "granted" : "denied",
    security_storage: "granted",
  };
};

const hasWindow = () => typeof window !== "undefined";

export const getStoredCookieConsent = () => {
  if (!hasWindow()) {
    return null;
  }

  try {
    const storedConsent = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!storedConsent) {
      return null;
    }

    const parsedConsent = JSON.parse(storedConsent);
    if (!parsedConsent?.categories || typeof parsedConsent.categories !== "object") {
      return null;
    }

    return {
      ...parsedConsent,
      categories: normalizeCookieCategories(parsedConsent.categories),
    };
  } catch (err) {
    return null;
  }
};

export const updateConsentSignals = (categories = defaultCookiePreferences) => {
  if (!hasWindow()) {
    return;
  }

  const normalizedCategories = normalizeCookieCategories(categories);
  const consentMode = getConsentMode(normalizedCategories);

  window.dataLayer = Array.isArray(window.dataLayer) ? window.dataLayer : [];
  window.dataLayer.push({
    event: "cookie_consent_update",
    cookie_consent: normalizedCategories,
    consent_mode: consentMode,
  });

  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", consentMode);
    if (normalizedCategories.statistics) {
      window.gtag("config", "G-64FJWNDP87", {
        page_path: window.location.pathname + window.location.search,
      });
    }
  }
};

export const saveCookieConsent = (payload) => {
  if (!hasWindow()) {
    return;
  }

  const normalizedPayload = {
    ...payload,
    categories: normalizeCookieCategories(payload?.categories),
  };

  window.localStorage.setItem(
    COOKIE_CONSENT_STORAGE_KEY,
    JSON.stringify(normalizedPayload)
  );
  window.localStorage.setItem(LEGACY_COOKIE_ACCEPTED_KEY, "1");
  updateConsentSignals(normalizedPayload.categories);
  window.dispatchEvent(
    new CustomEvent(COOKIE_CONSENT_UPDATED_EVENT, {
      detail: normalizedPayload,
    })
  );
};

export const hasStatisticsConsent = () => {
  const storedConsent = getStoredCookieConsent();

  return storedConsent?.categories?.statistics !== false;
};
